import WidgetTextPresentation from 'components/WidgetText/WidgetTextPresentation'

export default {
  Presentation: WidgetTextPresentation,
}
